import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import GenericModal from '../../../components/modal/GenericModal';
import { useManageGetRequest } from '../../../hooks/useManageGetRequest/useManageGetRequest';
import { useManagePostRequest } from '../../../hooks/useManagePostRequest/useManagePostRequest';
import { getComentariosPostulanteAPI, registrarComentarioPostulanteAPI } from '../../../consumers/backendApisUrls';

const LARGO_MAXIMO_COMENTARIO = 500;

const ComentariosPostulanteModal = ({ toggleModal, postulante = {}, nombreConvocatoria }) => {
    const [comentarios, setComentarios] = useState([]);
    const [comentario, setComentario] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [isSending, setIsSending] = useState(false);
    const [manageGetRequest] = useManageGetRequest();
    const [managePostRequest] = useManagePostRequest();

    const cargarComentarios = async () => {
        if (!postulante?.idPostulante) return;
        setIsLoading(true);
        try {
            await manageGetRequest(getComentariosPostulanteAPI(postulante.idPostulante), (response) => {
                setComentarios(Array.isArray(response?.data) ? response.data : []);
            }, false);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        cargarComentarios();
    }, []);

    const handleGuardar = async () => {
        const texto = comentario.trim();
        if (!texto || texto.length > LARGO_MAXIMO_COMENTARIO || isSending) return;
        setIsSending(true);
        try {
            await managePostRequest(registrarComentarioPostulanteAPI(),
                { IdPostulante: postulante.idPostulante, Comentario: texto },
                async () => {
                    toast.success('Comentario registrado correctamente.');
                    setComentario('');
                    await cargarComentarios();
                }, false);
        } finally {
            setIsSending(false);
        }
    };

    return (
        <GenericModal showModal={toggleModal} titulo="Comentarios de GDH" width="700px">
            <div className="modal-body">
                <div className="mb-3">
                    {postulante?.nombrePostulante && <div><strong>Postulante:</strong> {postulante.nombrePostulante}</div>}
                    {nombreConvocatoria && <div><strong>Convocatoria:</strong> {nombreConvocatoria}</div>}
                </div>

                <label className="modal-label mb-1">Historial</label>
                <div className="border rounded p-2 mb-3" style={{ maxHeight: '260px', overflowY: 'auto' }}>
                    {isLoading && <p className="text-muted mb-0" style={{ fontSize: 13 }}>Cargando...</p>}
                    {!isLoading && comentarios.length === 0 &&
                        <p className="text-muted mb-0" style={{ fontSize: 13 }}>Sin comentarios registrados.</p>
                    }
                    {!isLoading && comentarios.map((item) => (
                        <div key={item.IdPostulanteComentario} className="mb-2">
                            <small className="text-muted d-block">{item.FechaRegistro} - {item.NombreUsuario}</small>
                            <div style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{item.Comentario}</div>
                        </div>
                    ))}
                </div>

                <div className="form-group">
                    <label className="modal-label mb-0 required">Nuevo comentario</label>
                    <textarea className="form-control" rows={4} maxLength={LARGO_MAXIMO_COMENTARIO}
                        value={comentario} disabled={isSending}
                        onChange={(e) => setComentario(e.target.value)}
                        placeholder="Escribe el comentario de GDH sobre el postulante" />
                    <small className="text-muted d-block text-right">{comentario.length}/{LARGO_MAXIMO_COMENTARIO}</small>
                </div>

                <div className="d-flex justify-content-end mt-3">
                    <button type="button" className="btn btn-outline-secondary mr-2" disabled={isSending}
                        onClick={toggleModal}>
                        Cancelar
                    </button>
                    <button type="button" className="btn generic-button-buscador"
                        disabled={isSending || comentario.trim().length === 0} onClick={handleGuardar}>
                        Guardar
                    </button>
                </div>
            </div>
        </GenericModal>
    );
};

export default ComentariosPostulanteModal;
